import { useState } from 'react';
import { Button } from '@givebutter/primitives/button';
import * as Combobox from '@givebutter/primitives/combobox';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Form from 'components/form';
import { AssigneeComboboxItems } from 'components/tasks/AssigneeComboboxItems';
import * as TaskAssignee from 'components/tasks/TaskAssignee';
import { useCrmMembers } from 'components/tasks/utils/useCrmMembers';
import { TaskFormValues } from 'components/tasks/utils/useTaskForm';
import useDebounce from 'customHooks/useDebounce';
import { useIsPending } from 'customHooks/useIsPending';

const AssignedToFormField = () => {
    const { setValue, watch, control } = Form.useGivebutterFormContext<TaskFormValues>();
    const assigned_to = watch('assigned_to');

    const [inputValue, setInputValue] = useState('');
    const searchTerm = useDebounce(inputValue);

    const [isPending, params] = useIsPending(
        {
            query: searchTerm || undefined,
            limit: 9999,
        },
        500,
    );

    const { data: members } = useCrmMembers(params);

    const assignee = members.find(m => m.id.toString() === assigned_to[0]);

    return (
        <Form.Combobox
            control={control}
            name="assigned_to"
            resource="assignee"
            allowMultiple={false}
            onChangeValue={() => {
                setValue('remind_at', null, { shouldDirty: true });
            }}
        >
            <Combobox.Trigger>
                {assignee ? (
                    <TaskAssignee.Root className="cursor-pointer hover:bg-gray-100">
                        <TaskAssignee.Content
                            assignee={assignee}
                            onRemove={e => {
                                e.preventDefault();
                                setValue('assigned_to', [], { shouldDirty: true });
                                setValue('remind_at', null, { shouldDirty: true });
                            }}
                        />
                    </TaskAssignee.Root>
                ) : (
                    <Button
                        variant="transparent"
                        shape="square"
                        className="hover:bg-gray-100"
                        aria-label="Assign"
                    >
                        <FontAwesomeIcon icon={faUser} className="text-gray-500" />
                    </Button>
                )}
            </Combobox.Trigger>
            <Combobox.Popover className="w-80" align="start">
                <Combobox.Search
                    value={inputValue}
                    onChangeValue={setInputValue}
                    placeholder="Search assignee"
                />
                <AssigneeComboboxItems isLoading={isPending} members={members} />
            </Combobox.Popover>
        </Form.Combobox>
    );
};

export { AssignedToFormField };
